import { render } from "./compte_creation.vue?vue&type=template&id=a6ff46f0"
import script from "./compte_creation.vue?vue&type=script&lang=js"
export * from "./compte_creation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Site résa/reservation.ogalo-saumurvaldeloire.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__